module.exports = __webpack_public_path__ + "static/media/icon_arrowBB_select.e1b7c9d4.svg";